import { AnyAction } from 'redux';

import { getLocations, Locations } from '@ttstr/api';
import { getLocationsReceived } from '@ttstr/reducers/locations';

import { ThunkActionCreator } from '.';

export const LOCATIONS_REQUESTED = 'LOCATIONS.LOCATIONS_REQUESTED';
export const LOCATIONS_ALREADY_RECEIVED = 'LOCATIONS.LOCATIONS_ALREADY_RECEIVED';
export const LOCATIONS_RECEIVED = 'LOCATIONS.LOCATIONS_RECEIVED';
export const LOCATIONS_FAILED = 'LOCATIONS.LOCATIONS_FAILED';

export interface LocationsReceivedAction extends AnyAction {
  payload: {
    locations: Locations;
  };
}

let requestLocationsAbortController: AbortController;
export const requestLocations: ThunkActionCreator = () => async (dispatch, getState) => {
  if (requestLocationsAbortController) requestLocationsAbortController.abort();

  requestLocationsAbortController = new AbortController();
  dispatch({
    type: LOCATIONS_REQUESTED,
  });

  try {
    // TODO This "cache" needs to be invalidated eventually
    if (getLocationsReceived(getState())) {
      dispatch({
        type: LOCATIONS_ALREADY_RECEIVED,
      });
      return;
    }

    const locations = await getLocations({ signal: requestLocationsAbortController.signal });
    dispatch<LocationsReceivedAction>({
      type: LOCATIONS_RECEIVED,
      payload: {
        locations,
      },
    });
  } catch (error) {
    dispatch({
      type: LOCATIONS_FAILED,
      payload: {
        error,
      },
    });
  }
};
